<template>
    <div>
        
        <!-- 文字 图片 video -->
        
        <div class='con_c'  > 
            <div v-if='content'>
                <div class='con_txt fw900 fs18'  v-if='content.length < 18'>
                    {{content}}
                </div>
                <div class='con_txt fw300 fs16 t_in'  v-if='content.length >= 18'>
                    {{content}}
                </div>

            </div>
            
            <div v-if='image && !video'>
                <div   class='con_img'  v-for=" (item,num) in image" :key='num' > 
                    <img :src="item" alt="">
                </div>
            </div>
            

            <div class='con_img' v-if='video'> 
                

                <video
                    id="myVideo"
                    
                    class="video-js"
                    controls
                    preload="auto"
                    :poster="video_img"
                    :src="video"
                    data-setup='{}'
                >
            
                </video>
            </div>
        </div> 
    </div>
    
</template>
<script >


    export default {
        name: 'report_child',
        data(){
            return{
                image: null,
                video:null,
                video_img: null,
                content: null,
            }
        },
        watch:{
            child_guid(val){
                this.load();
            },
            txtM_c(val){
                let that = this;
                if(!val){
                    that.image = null ;
                    that.video = null;
                    that.video_img = null ;
                    that.content = null ;
                    
                }else{
                    that.load()
                }
            }

        },
        props: ['child_guid','txtM_c'],

        methods: {
            load(){
                let that = this;
                that.$myAjax.get("admin/service/admin/report/article/data/info?guid="+that.child_guid).then(function(res){
                    let data1 = res.data.data;
                    that.image = data1.image ;
                    that.video = data1.video;
                    that.video_img = data1.videoImage ;
                    that.content = data1.content ;

                    
                })
            }
        },
        mounted: function(){
            this.load();
            
        }
        
    }
</script>
<style scoped>
    #myVideo{
        width: 100% !important;
        height: 220px !important;
    }
    .con_c{
        width: 80%;
        margin-left: 10%;
        min-height: 300px;
        max-height: 500px;
        padding: 10px;
        overflow-y: auto;
        overflow-x: hidden;
        
        border: 1px solid #e8eaec;
        border-radius: 10px;
    }
    .con_txt{
        margin-bottom: 20px;
    }
    .con_img{
        width: 100%;
        position: relative;
        height: auto;
    }
    .con_img img{
       
        width: 100%;
    }
    .t_in{
        text-indent: 32px;

    }
   

</style>